/*
 * @Description: Text-to-Music SEO 页面国际化配置
 */

export default {
    en: {
        // Hero Section
        heroTitle: "Create Unique Music with 微鲤AI\'s",
        heroHighlight: 'AI Music Generator',

        // Why Choose Section
        whyChooseTitle: "Why Choose 微鲤AI\'s AI Music Generator?",
        whyChooseDesc:
            "Welcome to 微鲤AI\'s AI Music Generator! Our innovative tool harnesses the power of artificial intelligence to create unique, royalty-free music tracks in seconds. Whether you're a video creator, game developer, or just a music lover, our generator is designed to meet your diverse needs. With various customization options available, you can easily choose the genre, tempo, and mood of your music, making your projects more engaging and appealing.",

        // Core Features Section
        featuresTitle: 'Core Features of Our AI Music Generator',
        featuresSubtitle:
            "微鲤AI\'s AI Music Generator utilizes sophisticated deep learning algorithms to analyze user inputs and generate high-quality music compositions. By simply providing basic information such as the desired genre and emotional tone, the AI system processes this data to create music that aligns with your specifications.",
        features: {
            music: {
                title: 'Text-to-Music Generation',
                desc: '微鲤AI utilizes sophisticated deep learning algorithms to analyze your text inputs and generate high-quality music compositions that match your specifications.',
            },
            style: {
                title: 'Multiple Music Styles',
                desc: 'Our technology supports a wide range of music styles, from classical to modern electronic, ensuring you find the perfect match for your project.',
            },
            customize: {
                title: 'Full Customization',
                desc: 'Choose the genre, tempo, and mood of your music with various customization options, making your projects more engaging and appealing.',
            },
            copyright: {
                title: 'Royalty-Free Music',
                desc: 'Create unique, royalty-free music tracks in seconds. Perfect for video creators, game developers, or music enthusiasts.',
            },
        },

        // How to Use Section
        howToTitle: 'How to Use the AI Music Generator',
        howToSubtitle:
            "Getting started with 微鲤AI\'s AI Music Generator is a breeze. Follow these simple steps:",
        steps: {
            step1: {
                title: 'Visit the Website',
                desc: 'Navigate to the 微鲤AI AI Music Generator page.',
            },
            step2: {
                title: 'Select Music Type',
                desc: 'Choose the genre of music you want to generate from the dropdown menu, such as Pop, Rock, Classical, or Electronic.',
            },
            step3: {
                title: 'Set Parameters',
                desc: 'Adjust the emotional tone, tempo, and length of the music according to your project needs. Options include upbeat, sentimental, or motivational themes.',
            },
            step4: {
                title: 'Generate Music',
                desc: 'Click the "Generate" button and wait a few seconds for your unique music track to be created.',
            },
            step5: {
                title: 'Download or Share',
                desc: 'The generated music track will be available for download, and you can also share it directly on social media platforms.',
            },
        },

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        faq: {
            q1: {
                question: "How does 微鲤AI\'s AI Music Generator work?",
                answer: 'You simply select the music type, set your parameters, and click "Generate." The AI will compose music tailored to your specifications.',
            },
            q2: {
                question: "Is 微鲤AI\'s AI Music Generator free to use?",
                answer: 'Yes, you can generate a number of music tracks for free each day. For additional features or commercial use, please consider our premium plans.',
            },
            q3: {
                question: 'Can I customize the generated music?',
                answer: 'Absolutely! You can customize the music type, emotional tone, and tempo to ensure the music meets your specific needs.',
            },
            q4: {
                question: 'What types of music can I generate?',
                answer: '微鲤AI supports various music genres including Pop, Rock, Classical, and Electronic. You can choose according to your preference.',
            },
            q5: {
                question: 'Is the generated music suitable for commercial use?',
                answer: 'Yes, music generated under our paid plans comes with a commercial license, allowing you to use it in YouTube videos, games, and other commercial projects.',
            },
        },
    },
    zh: {
        // Hero Section
        heroTitle: '使用 微鲤AI 创作独特音乐',
        heroHighlight: 'AI 音乐生成器',

        // Why Choose Section
        whyChooseTitle: '为什么选择 微鲤AI 的 AI 音乐生成器？',
        whyChooseDesc:
            '欢迎使用 微鲤AI 的 AI 音乐生成器！我们的创新工具利用人工智能的力量，在几秒钟内创作出独特的免版税音乐。无论您是视频创作者、游戏开发者还是音乐爱好者，我们的生成器都能满足您的多样化需求。通过各种自定义选项，您可以轻松选择音乐的风格、节奏和情绪，让您的项目更具吸引力。',

        // Core Features Section
        featuresTitle: 'AI 音乐生成器的核心功能',
        featuresSubtitle:
            '微鲤AI 的 AI 音乐生成器利用先进的深度学习算法分析用户输入，生成高质量的音乐作品。只需提供所需的风格和情感基调等基本信息，AI 系统就会处理这些数据，创作出符合您要求的音乐。',
        features: {
            music: {
                title: '文字转音乐生成',
                desc: '微鲤AI 利用先进的深度学习算法分析您的文字输入，生成与您要求相匹配的高质量音乐作品。',
            },
            style: {
                title: '多种音乐风格',
                desc: '我们的技术支持从古典到现代电子音乐的多种音乐风格，确保您为项目找到完美匹配。',
            },
            customize: {
                title: '完全自定义',
                desc: '通过各种自定义选项选择音乐的风格、节奏和情绪，让您的项目更具吸引力。',
            },
            copyright: {
                title: '免版税音乐',
                desc: '在几秒钟内创作独特的免版税音乐。非常适合视频创作者、游戏开发者或音乐爱好者。',
            },
        },

        // How to Use Section
        howToTitle: '如何使用 AI 音乐生成器',
        howToSubtitle:
            '开始使用 微鲤AI 的 AI 音乐生成器非常简单。请按照以下步骤操作：',
        steps: {
            step1: {
                title: '访问网站',
                desc: '导航到 微鲤AI AI 音乐生成器页面。',
            },
            step2: {
                title: '选择音乐类型',
                desc: '从下拉菜单中选择您想要生成的音乐风格，如流行、摇滚、古典或电子音乐。',
            },
            step3: {
                title: '设置参数',
                desc: '根据您的项目需求调整情感基调、节奏和音乐长度。选项包括欢快、感伤或励志主题。',
            },
            step4: {
                title: '生成音乐',
                desc: '点击"生成"按钮，等待几秒钟即可创作出您独特的音乐作品。',
            },
            step5: {
                title: '下载或分享',
                desc: '生成的音乐将可供下载，您也可以直接分享到社交媒体平台。',
            },
        },

        // FAQ Section
        faqTitle: '常见问题',
        faq: {
            q1: {
                question: '微鲤AI 的 AI 音乐生成器是如何工作的？',
                answer: '您只需选择音乐类型、设置参数，然后点击"生成"。AI 将根据您的要求创作音乐。',
            },
            q2: {
                question: '微鲤AI 的 AI 音乐生成器可以免费使用吗？',
                answer: '是的，您每天可以免费生成一定数量的音乐。如需更多功能或商业用途，请考虑我们的付费计划。',
            },
            q3: {
                question: '我可以自定义生成的音乐吗？',
                answer: '当然可以！您可以自定义音乐类型、情感基调和节奏，确保音乐满足您的特定需求。',
            },
            q4: {
                question: '我可以生成哪些类型的音乐？',
                answer: '微鲤AI 支持多种音乐风格，包括流行、摇滚、古典和电子音乐。您可以根据喜好选择。',
            },
            q5: {
                question: '生成的音乐适合商业使用吗？',
                answer: '是的，付费计划下生成的音乐附带商业许可，允许您在 YouTube 视频、游戏和其他商业项目中使用。',
            },
        },
    },
    ja: {
        heroTitle: '微鲤AI で独自の音楽を作成',
        heroHighlight: 'AI 音楽ジェネレーター',
        whyChooseTitle: '微鲤AI の AI 音楽ジェネレーターを選ぶ理由',
        whyChooseDesc:
            '微鲤AI の AI 音楽ジェネレーターへようこそ！当社の革新的なツールは、人工知能の力を活用して、数秒でユニークなロイヤリティフリーの音楽トラックを作成します。ビデオクリエイター、ゲーム開発者、または単なる音楽愛好家であっても、当社のジェネレーターはお客様の多様なニーズに対応できるように設計されています。',
        featuresTitle: 'AI 音楽ジェネレーターのコア機能',
        featuresSubtitle:
            '微鲤AI の AI 音楽ジェネレーターは、高度なディープラーニングアルゴリズムを利用してユーザー入力を分析し、高品質の音楽作品を生成します。',
        features: {
            music: {
                title: 'テキストから音楽生成',
                desc: '微鲤AI は高度なディープラーニングアルゴリズムを利用して、テキスト入力を分析し、仕様に合った高品質の音楽作品を生成します。',
            },
            style: {
                title: '複数の音楽スタイル',
                desc: '当社の技術は、クラシックからモダンエレクトロニックまで、幅広い音楽スタイルをサポートしています。',
            },
            customize: {
                title: '完全カスタマイズ',
                desc: 'さまざまなカスタマイズオプションで音楽のジャンル、テンポ、ムードを選択できます。',
            },
            copyright: {
                title: 'ロイヤリティフリー音楽',
                desc: '数秒でユニークなロイヤリティフリーの音楽トラックを作成。ビデオクリエイター、ゲーム開発者、音楽愛好家に最適です。',
            },
        },
        howToTitle: 'AI 音楽ジェネレーターの使い方',
        howToSubtitle:
            '微鲤AI の AI 音楽ジェネレーターの使い始めは簡単です。以下の手順に従ってください：',
        steps: {
            step1: {
                title: 'ウェブサイトにアクセス',
                desc: '微鲤AI AI 音楽ジェネレーターページに移動します。',
            },
            step2: {
                title: '音楽タイプを選択',
                desc: 'ドロップダウンメニューから生成したい音楽のジャンルを選択します。',
            },
            step3: {
                title: 'パラメータを設定',
                desc: 'プロジェクトのニーズに合わせて、感情的なトーン、テンポ、音楽の長さを調整します。',
            },
            step4: {
                title: '音楽を生成',
                desc: '「生成」ボタンをクリックし、数秒でユニークな音楽トラックが作成されるのを待ちます。',
            },
            step5: {
                title: 'ダウンロードまたは共有',
                desc: '生成された音楽トラックはダウンロード可能で、ソーシャルメディアプラットフォームで直接共有することもできます。',
            },
        },
        faqTitle: 'よくある質問',
        faq: {
            q1: {
                question: '微鲤AI の AI 音楽ジェネレーターはどのように機能しますか？',
                answer: '音楽タイプを選択し、パラメータを設定して「生成」をクリックするだけです。AI が仕様に合わせた音楽を作曲します。',
            },
            q2: {
                question: '微鲤AI の AI 音楽ジェネレーターは無料で使えますか？',
                answer: 'はい、毎日一定数の音楽トラックを無料で生成できます。追加機能や商用利用については、プレミアムプランをご検討ください。',
            },
            q3: {
                question: '生成された音楽をカスタマイズできますか？',
                answer: 'もちろんです！音楽タイプ、感情的なトーン、テンポをカスタマイズして、特定のニーズに合った音楽を作成できます。',
            },
            q4: {
                question: 'どのような種類の音楽を生成できますか？',
                answer: '微鲤AI は、ポップ、ロック、クラシック、エレクトロニックなど、さまざまな音楽ジャンルをサポートしています。',
            },
            q5: {
                question: '生成された音楽は商用利用に適していますか？',
                answer: 'はい、有料プランで生成された音楽には商用ライセンスが付属しており、YouTube 動画、ゲーム、その他の商用プロジェクトで使用できます。',
            },
        },
    },
    ko: {
        heroTitle: 'WeryAI로 독특한 음악 만들기',
        heroHighlight: 'AI 음악 생성기',
        whyChooseTitle: '微鲤AI AI 음악 생성기를 선택해야 하는 이유',
        whyChooseDesc:
            '微鲤AI AI 음악 생성기에 오신 것을 환영합니다! 우리의 혁신적인 도구는 인공 지능의 힘을 활용하여 몇 초 만에 독특한 로열티 프리 음악 트랙을 만듭니다. 비디오 크리에이터, 게임 개발자 또는 음악 애호가이든 관계없이 당사의 생성기는 다양한 요구 사항을 충족하도록 설계되었습니다.',
        featuresTitle: 'AI 음악 생성기의 핵심 기능',
        featuresSubtitle:
            '微鲤AI AI 음악 생성기는 정교한 딥 러닝 알고리즘을 활용하여 사용자 입력을 분석하고 고품질 음악 작품을 생성합니다.',
        features: {
            music: {
                title: '텍스트-음악 생성',
                desc: 'WeryAI는 정교한 딥 러닝 알고리즘을 활용하여 텍스트 입력을 분석하고 사양에 맞는 고품질 음악 작품을 생성합니다.',
            },
            style: {
                title: '다양한 음악 스타일',
                desc: '우리 기술은 클래식에서 현대 전자 음악까지 다양한 음악 스타일을 지원합니다.',
            },
            customize: {
                title: '완전한 사용자 정의',
                desc: '다양한 사용자 정의 옵션으로 음악의 장르, 템포, 분위기를 선택할 수 있습니다.',
            },
            copyright: {
                title: '로열티 프리 음악',
                desc: '몇 초 만에 독특한 로열티 프리 음악 트랙을 만드세요. 비디오 크리에이터, 게임 개발자, 음악 애호가에게 완벽합니다.',
            },
        },
        howToTitle: 'AI 음악 생성기 사용 방법',
        howToSubtitle:
            '微鲤AI AI 음악 생성기 시작하기는 매우 쉽습니다. 다음 간단한 단계를 따르세요:',
        steps: {
            step1: {
                title: '웹사이트 방문',
                desc: '微鲤AI AI 음악 생성기 페이지로 이동합니다.',
            },
            step2: {
                title: '음악 유형 선택',
                desc: '드롭다운 메뉴에서 생성하려는 음악 장르를 선택합니다.',
            },
            step3: {
                title: '매개변수 설정',
                desc: '프로젝트 요구 사항에 따라 감정적 톤, 템포, 음악 길이를 조정합니다.',
            },
            step4: {
                title: '음악 생성',
                desc: '"생성" 버튼을 클릭하고 몇 초 동안 기다리면 독특한 음악 트랙이 만들어집니다.',
            },
            step5: {
                title: '다운로드 또는 공유',
                desc: '생성된 음악 트랙은 다운로드할 수 있으며 소셜 미디어 플랫폼에서 직접 공유할 수도 있습니다.',
            },
        },
        faqTitle: '자주 묻는 질문',
        faq: {
            q1: {
                question: '微鲤AI AI 음악 생성기는 어떻게 작동하나요?',
                answer: '음악 유형을 선택하고 매개변수를 설정한 다음 "생성"을 클릭하면 됩니다. AI가 사양에 맞게 음악을 작곡합니다.',
            },
            q2: {
                question: '微鲤AI AI 음악 생성기는 무료로 사용할 수 있나요?',
                answer: '네, 매일 일정 수의 음악 트랙을 무료로 생성할 수 있습니다. 추가 기능이나 상업적 사용을 위해서는 프리미엄 플랜을 고려해 주세요.',
            },
            q3: {
                question: '생성된 음악을 사용자 정의할 수 있나요?',
                answer: '물론입니다! 음악 유형, 감정적 톤, 템포를 사용자 정의하여 특정 요구 사항에 맞는 음악을 만들 수 있습니다.',
            },
            q4: {
                question: '어떤 종류의 음악을 생성할 수 있나요?',
                answer: 'WeryAI는 팝, 록, 클래식, 일렉트로닉 등 다양한 음악 장르를 지원합니다.',
            },
            q5: {
                question: '생성된 음악은 상업적 사용에 적합한가요?',
                answer: '네, 유료 플랜에서 생성된 음악에는 상업 라이선스가 포함되어 YouTube 동영상, 게임 및 기타 상업 프로젝트에서 사용할 수 있습니다.',
            },
        },
    },
    es: {
        heroTitle: 'Crea Música Única con 微鲤AI',
        heroHighlight: 'Generador de Música AI',
        whyChooseTitle: '¿Por qué elegir el Generador de Música AI de 微鲤AI?',
        whyChooseDesc:
            '¡Bienvenido al Generador de Música AI de 微鲤AI! Nuestra herramienta innovadora aprovecha el poder de la inteligencia artificial para crear pistas musicales únicas y libres de regalías en segundos. Ya seas creador de videos, desarrollador de juegos o simplemente un amante de la música, nuestro generador está diseñado para satisfacer tus diversas necesidades.',
        featuresTitle: 'Características Principales de Nuestro Generador de Música AI',
        featuresSubtitle:
            'El Generador de Música AI de 微鲤AI utiliza algoritmos sofisticados de aprendizaje profundo para analizar las entradas del usuario y generar composiciones musicales de alta calidad.',
        features: {
            music: {
                title: 'Generación de Texto a Música',
                desc: '微鲤AI utiliza algoritmos sofisticados de aprendizaje profundo para analizar tus entradas de texto y generar composiciones musicales de alta calidad.',
            },
            style: {
                title: 'Múltiples Estilos Musicales',
                desc: 'Nuestra tecnología soporta una amplia gama de estilos musicales, desde clásico hasta electrónico moderno.',
            },
            customize: {
                title: 'Personalización Completa',
                desc: 'Elige el género, tempo y estado de ánimo de tu música con varias opciones de personalización.',
            },
            copyright: {
                title: 'Música Libre de Regalías',
                desc: 'Crea pistas musicales únicas y libres de regalías en segundos. Perfecto para creadores de videos, desarrolladores de juegos o entusiastas de la música.',
            },
        },
        howToTitle: 'Cómo Usar el Generador de Música AI',
        howToSubtitle:
            'Comenzar con el Generador de Música AI de 微鲤AI es muy fácil. Sigue estos simples pasos:',
        steps: {
            step1: {
                title: 'Visita el Sitio Web',
                desc: 'Navega a la página del Generador de Música AI de 微鲤AI.',
            },
            step2: {
                title: 'Selecciona el Tipo de Música',
                desc: 'Elige el género de música que deseas generar del menú desplegable.',
            },
            step3: {
                title: 'Configura los Parámetros',
                desc: 'Ajusta el tono emocional, tempo y duración de la música según las necesidades de tu proyecto.',
            },
            step4: {
                title: 'Genera la Música',
                desc: 'Haz clic en el botón "Generar" y espera unos segundos para que se cree tu pista musical única.',
            },
            step5: {
                title: 'Descarga o Comparte',
                desc: 'La pista musical generada estará disponible para descargar, y también puedes compartirla directamente en plataformas de redes sociales.',
            },
        },
        faqTitle: 'Preguntas Frecuentes',
        faq: {
            q1: {
                question: '¿Cómo funciona el Generador de Música AI de 微鲤AI?',
                answer: 'Simplemente selecciona el tipo de música, configura tus parámetros y haz clic en "Generar". La IA compondrá música adaptada a tus especificaciones.',
            },
            q2: {
                question: '¿El Generador de Música AI de 微鲤AI es gratuito?',
                answer: 'Sí, puedes generar una cantidad de pistas musicales gratis cada día. Para funciones adicionales o uso comercial, considera nuestros planes premium.',
            },
            q3: {
                question: '¿Puedo personalizar la música generada?',
                answer: '¡Absolutamente! Puedes personalizar el tipo de música, tono emocional y tempo para asegurar que la música cumpla con tus necesidades específicas.',
            },
            q4: {
                question: '¿Qué tipos de música puedo generar?',
                answer: '微鲤AI soporta varios géneros musicales incluyendo Pop, Rock, Clásico y Electrónico.',
            },
            q5: {
                question: '¿La música generada es adecuada para uso comercial?',
                answer: 'Sí, la música generada bajo nuestros planes pagos viene con una licencia comercial, permitiéndote usarla en videos de YouTube, juegos y otros proyectos comerciales.',
            },
        },
    },
    fr: {
        heroTitle: 'Créez de la Musique Unique avec 微鲤AI',
        heroHighlight: 'Générateur de Musique IA',
        whyChooseTitle: 'Pourquoi Choisir le Générateur de Musique IA de 微鲤AI?',
        whyChooseDesc:
            'Bienvenue dans le Générateur de Musique IA de 微鲤AI! Notre outil innovant exploite la puissance de l\'intelligence artificielle pour créer des pistes musicales uniques et libres de droits en quelques secondes.',
        featuresTitle: 'Fonctionnalités Principales de Notre Générateur de Musique IA',
        featuresSubtitle:
            'Le Générateur de Musique IA de 微鲤AI utilise des algorithmes sophistiqués d\'apprentissage profond pour analyser les entrées des utilisateurs et générer des compositions musicales de haute qualité.',
        features: {
            music: {
                title: 'Génération Texte vers Musique',
                desc: '微鲤AI utilise des algorithmes sophistiqués d\'apprentissage profond pour analyser vos entrées textuelles et générer des compositions musicales de haute qualité.',
            },
            style: {
                title: 'Multiples Styles Musicaux',
                desc: 'Notre technologie prend en charge une large gamme de styles musicaux, du classique à l\'électronique moderne.',
            },
            customize: {
                title: 'Personnalisation Complète',
                desc: 'Choisissez le genre, le tempo et l\'ambiance de votre musique avec diverses options de personnalisation.',
            },
            copyright: {
                title: 'Musique Libre de Droits',
                desc: 'Créez des pistes musicales uniques et libres de droits en quelques secondes. Parfait pour les créateurs de vidéos, développeurs de jeux ou passionnés de musique.',
            },
        },
        howToTitle: 'Comment Utiliser le Générateur de Musique IA',
        howToSubtitle:
            'Commencer avec le Générateur de Musique IA de 微鲤AI est un jeu d\'enfant. Suivez ces étapes simples:',
        steps: {
            step1: {
                title: 'Visitez le Site Web',
                desc: 'Naviguez vers la page du Générateur de Musique IA 微鲤AI.',
            },
            step2: {
                title: 'Sélectionnez le Type de Musique',
                desc: 'Choisissez le genre de musique que vous souhaitez générer dans le menu déroulant.',
            },
            step3: {
                title: 'Définissez les Paramètres',
                desc: 'Ajustez le ton émotionnel, le tempo et la durée de la musique selon les besoins de votre projet.',
            },
            step4: {
                title: 'Générez la Musique',
                desc: 'Cliquez sur le bouton "Générer" et attendez quelques secondes pour que votre piste musicale unique soit créée.',
            },
            step5: {
                title: 'Téléchargez ou Partagez',
                desc: 'La piste musicale générée sera disponible au téléchargement, et vous pourrez également la partager directement sur les plateformes de médias sociaux.',
            },
        },
        faqTitle: 'Questions Fréquemment Posées',
        faq: {
            q1: {
                question: 'Comment fonctionne le Générateur de Musique IA de 微鲤AI?',
                answer: 'Vous sélectionnez simplement le type de musique, définissez vos paramètres et cliquez sur "Générer". L\'IA composera de la musique adaptée à vos spécifications.',
            },
            q2: {
                question: 'Le Générateur de Musique IA de 微鲤AI est-il gratuit?',
                answer: 'Oui, vous pouvez générer un certain nombre de pistes musicales gratuitement chaque jour. Pour des fonctionnalités supplémentaires ou une utilisation commerciale, veuillez considérer nos forfaits premium.',
            },
            q3: {
                question: 'Puis-je personnaliser la musique générée?',
                answer: 'Absolument! Vous pouvez personnaliser le type de musique, le ton émotionnel et le tempo pour vous assurer que la musique répond à vos besoins spécifiques.',
            },
            q4: {
                question: 'Quels types de musique puis-je générer?',
                answer: '微鲤AI prend en charge divers genres musicaux, notamment Pop, Rock, Classique et Électronique.',
            },
            q5: {
                question: 'La musique générée convient-elle à un usage commercial?',
                answer: 'Oui, la musique générée dans le cadre de nos forfaits payants est accompagnée d\'une licence commerciale, vous permettant de l\'utiliser dans des vidéos YouTube, des jeux et d\'autres projets commerciaux.',
            },
        },
    },
    de: {
        heroTitle: 'Erstellen Sie einzigartige Musik mit 微鲤AI',
        heroHighlight: 'KI-Musikgenerator',
        whyChooseTitle: 'Warum den KI-Musikgenerator von 微鲤AI wählen?',
        whyChooseDesc:
            'Willkommen beim KI-Musikgenerator von 微鲤AI! Unser innovatives Tool nutzt die Kraft der künstlichen Intelligenz, um in Sekunden einzigartige, lizenzfreie Musiktitel zu erstellen.',
        featuresTitle: 'Kernfunktionen unseres KI-Musikgenerators',
        featuresSubtitle:
            'Der KI-Musikgenerator von 微鲤AI verwendet ausgefeilte Deep-Learning-Algorithmen, um Benutzereingaben zu analysieren und hochwertige Musikkompositionen zu generieren.',
        features: {
            music: {
                title: 'Text-zu-Musik-Generierung',
                desc: '微鲤AI verwendet ausgefeilte Deep-Learning-Algorithmen, um Ihre Texteingaben zu analysieren und hochwertige Musikkompositionen zu generieren.',
            },
            style: {
                title: 'Mehrere Musikstile',
                desc: 'Unsere Technologie unterstützt eine breite Palette von Musikstilen, von Klassik bis zu moderner Elektronik.',
            },
            customize: {
                title: 'Vollständige Anpassung',
                desc: 'Wählen Sie mit verschiedenen Anpassungsoptionen das Genre, Tempo und die Stimmung Ihrer Musik.',
            },
            copyright: {
                title: 'Lizenzfreie Musik',
                desc: 'Erstellen Sie in Sekunden einzigartige, lizenzfreie Musiktitel. Perfekt für Videokünstler, Spieleentwickler oder Musikliebhaber.',
            },
        },
        howToTitle: 'So verwenden Sie den KI-Musikgenerator',
        howToSubtitle:
            'Der Einstieg in den KI-Musikgenerator von 微鲤AI ist ein Kinderspiel. Befolgen Sie diese einfachen Schritte:',
        steps: {
            step1: {
                title: 'Besuchen Sie die Website',
                desc: 'Navigieren Sie zur 微鲤AI KI-Musikgenerator-Seite.',
            },
            step2: {
                title: 'Musiktyp auswählen',
                desc: 'Wählen Sie im Dropdown-Menü das Genre der Musik aus, die Sie generieren möchten.',
            },
            step3: {
                title: 'Parameter einstellen',
                desc: 'Passen Sie den emotionalen Ton, das Tempo und die Länge der Musik entsprechend Ihren Projektanforderungen an.',
            },
            step4: {
                title: 'Musik generieren',
                desc: 'Klicken Sie auf die Schaltfläche "Generieren" und warten Sie einige Sekunden, bis Ihr einzigartiger Musiktitel erstellt wird.',
            },
            step5: {
                title: 'Herunterladen oder Teilen',
                desc: 'Der generierte Musiktitel steht zum Download bereit und kann auch direkt auf Social-Media-Plattformen geteilt werden.',
            },
        },
        faqTitle: 'Häufig gestellte Fragen',
        faq: {
            q1: {
                question: 'Wie funktioniert der KI-Musikgenerator von 微鲤AI?',
                answer: 'Sie wählen einfach den Musiktyp aus, stellen Ihre Parameter ein und klicken auf "Generieren". Die KI wird Musik nach Ihren Vorgaben komponieren.',
            },
            q2: {
                question: 'Ist der KI-Musikgenerator von 微鲤AI kostenlos?',
                answer: 'Ja, Sie können jeden Tag eine bestimmte Anzahl von Musiktiteln kostenlos generieren. Für zusätzliche Funktionen oder kommerzielle Nutzung ziehen Sie bitte unsere Premium-Pläne in Betracht.',
            },
            q3: {
                question: 'Kann ich die generierte Musik anpassen?',
                answer: 'Absolut! Sie können den Musiktyp, den emotionalen Ton und das Tempo anpassen, um sicherzustellen, dass die Musik Ihren spezifischen Anforderungen entspricht.',
            },
            q4: {
                question: 'Welche Musikarten kann ich generieren?',
                answer: '微鲤AI unterstützt verschiedene Musikgenres, darunter Pop, Rock, Klassik und Elektronik.',
            },
            q5: {
                question: 'Ist die generierte Musik für die kommerzielle Nutzung geeignet?',
                answer: 'Ja, Musik, die im Rahmen unserer kostenpflichtigen Pläne generiert wird, enthält eine kommerzielle Lizenz, die die Verwendung in YouTube-Videos, Spielen und anderen kommerziellen Projekten ermöglicht.',
            },
        },
    },
    ru: {
        heroTitle: 'Создавайте уникальную музыку с 微鲤AI',
        heroHighlight: 'ИИ Генератор Музыки',
        whyChooseTitle: 'Почему стоит выбрать ИИ Генератор Музыки 微鲤AI?',
        whyChooseDesc:
            'Добро пожаловать в ИИ Генератор Музыки 微鲤AI! Наш инновационный инструмент использует силу искусственного интеллекта для создания уникальных бесплатных музыкальных треков за считанные секунды.',
        featuresTitle: 'Основные функции нашего ИИ Генератора Музыки',
        featuresSubtitle:
            'ИИ Генератор Музыки 微鲤AI использует сложные алгоритмы глубокого обучения для анализа пользовательского ввода и создания высококачественных музыкальных композиций.',
        features: {
            music: {
                title: 'Генерация музыки из текста',
                desc: '微鲤AI использует сложные алгоритмы глубокого обучения для анализа вашего текстового ввода и создания высококачественных музыкальных композиций.',
            },
            style: {
                title: 'Множество музыкальных стилей',
                desc: 'Наша технология поддерживает широкий спектр музыкальных стилей, от классики до современной электроники.',
            },
            customize: {
                title: 'Полная настройка',
                desc: 'Выбирайте жанр, темп и настроение музыки с помощью различных параметров настройки.',
            },
            copyright: {
                title: 'Бесплатная музыка',
                desc: 'Создавайте уникальные бесплатные музыкальные треки за считанные секунды. Идеально подходит для создателей видео, разработчиков игр или любителей музыки.',
            },
        },
        howToTitle: 'Как использовать ИИ Генератор Музыки',
        howToSubtitle:
            'Начать работу с ИИ Генератором Музыки 微鲤AI очень просто. Следуйте этим простым шагам:',
        steps: {
            step1: {
                title: 'Посетите сайт',
                desc: 'Перейдите на страницу ИИ Генератора Музыки 微鲤AI.',
            },
            step2: {
                title: 'Выберите тип музыки',
                desc: 'Выберите жанр музыки, который хотите создать, из выпадающего меню.',
            },
            step3: {
                title: 'Установите параметры',
                desc: 'Настройте эмоциональный тон, темп и продолжительность музыки в соответствии с потребностями вашего проекта.',
            },
            step4: {
                title: 'Сгенерируйте музыку',
                desc: 'Нажмите кнопку "Сгенерировать" и подождите несколько секунд, пока создается ваш уникальный музыкальный трек.',
            },
            step5: {
                title: 'Скачайте или поделитесь',
                desc: 'Сгенерированный музыкальный трек будет доступен для скачивания, и вы также можете поделиться им напрямую в социальных сетях.',
            },
        },
        faqTitle: 'Часто задаваемые вопросы',
        faq: {
            q1: {
                question: 'Как работает ИИ Генератор Музыки 微鲤AI?',
                answer: 'Вы просто выбираете тип музыки, устанавливаете параметры и нажимаете "Сгенерировать". ИИ создаст музыку в соответствии с вашими требованиями.',
            },
            q2: {
                question: 'ИИ Генератор Музыки 微鲤AI бесплатный?',
                answer: 'Да, вы можете бесплатно генерировать определенное количество музыкальных треков каждый день. Для дополнительных функций или коммерческого использования рассмотрите наши премиум-планы.',
            },
            q3: {
                question: 'Могу ли я настроить сгенерированную музыку?',
                answer: 'Конечно! Вы можете настроить тип музыки, эмоциональный тон и темп, чтобы убедиться, что музыка соответствует вашим конкретным потребностям.',
            },
            q4: {
                question: 'Какие типы музыки я могу генерировать?',
                answer: '微鲤AI поддерживает различные музыкальные жанры, включая поп, рок, классику и электронику.',
            },
            q5: {
                question: 'Подходит ли сгенерированная музыка для коммерческого использования?',
                answer: 'Да, музыка, сгенерированная в рамках наших платных планов, поставляется с коммерческой лицензией, позволяющей использовать ее в видео на YouTube, играх и других коммерческих проектах.',
            },
        },
    },
    pt: {
        heroTitle: 'Crie Música Única com 微鲤AI',
        heroHighlight: 'Gerador de Música IA',
        whyChooseTitle: 'Por que Escolher o Gerador de Música IA da 微鲤AI?',
        whyChooseDesc:
            'Bem-vindo ao Gerador de Música IA da 微鲤AI! Nossa ferramenta inovadora aproveita o poder da inteligência artificial para criar faixas musicais únicas e livres de royalties em segundos.',
        featuresTitle: 'Recursos Principais do Nosso Gerador de Música IA',
        featuresSubtitle:
            'O Gerador de Música IA da 微鲤AI utiliza algoritmos sofisticados de aprendizado profundo para analisar entradas do usuário e gerar composições musicais de alta qualidade.',
        features: {
            music: {
                title: 'Geração de Texto para Música',
                desc: '微鲤AI utiliza algoritmos sofisticados de aprendizado profundo para analisar suas entradas de texto e gerar composições musicais de alta qualidade.',
            },
            style: {
                title: 'Múltiplos Estilos Musicais',
                desc: 'Nossa tecnologia suporta uma ampla gama de estilos musicais, desde clássico até eletrônico moderno.',
            },
            customize: {
                title: 'Personalização Completa',
                desc: 'Escolha o gênero, tempo e humor da sua música com várias opções de personalização.',
            },
            copyright: {
                title: 'Música Livre de Royalties',
                desc: 'Crie faixas musicais únicas e livres de royalties em segundos. Perfeito para criadores de vídeo, desenvolvedores de jogos ou entusiastas de música.',
            },
        },
        howToTitle: 'Como Usar o Gerador de Música IA',
        howToSubtitle:
            'Começar com o Gerador de Música IA da 微鲤AI é muito fácil. Siga estes passos simples:',
        steps: {
            step1: {
                title: 'Visite o Site',
                desc: 'Navegue até a página do Gerador de Música IA da 微鲤AI.',
            },
            step2: {
                title: 'Selecione o Tipo de Música',
                desc: 'Escolha o gênero de música que deseja gerar no menu suspenso.',
            },
            step3: {
                title: 'Defina os Parâmetros',
                desc: 'Ajuste o tom emocional, tempo e duração da música de acordo com as necessidades do seu projeto.',
            },
            step4: {
                title: 'Gere a Música',
                desc: 'Clique no botão "Gerar" e aguarde alguns segundos para que sua faixa musical única seja criada.',
            },
            step5: {
                title: 'Baixe ou Compartilhe',
                desc: 'A faixa musical gerada estará disponível para download, e você também pode compartilhá-la diretamente nas plataformas de mídia social.',
            },
        },
        faqTitle: 'Perguntas Frequentes',
        faq: {
            q1: {
                question: 'Como funciona o Gerador de Música IA da 微鲤AI?',
                answer: 'Você simplesmente seleciona o tipo de música, define seus parâmetros e clica em "Gerar". A IA irá compor música adaptada às suas especificações.',
            },
            q2: {
                question: 'O Gerador de Música IA da 微鲤AI é gratuito?',
                answer: 'Sim, você pode gerar um número de faixas musicais gratuitamente todos os dias. Para recursos adicionais ou uso comercial, considere nossos planos premium.',
            },
            q3: {
                question: 'Posso personalizar a música gerada?',
                answer: 'Absolutamente! Você pode personalizar o tipo de música, tom emocional e tempo para garantir que a música atenda às suas necessidades específicas.',
            },
            q4: {
                question: 'Que tipos de música posso gerar?',
                answer: '微鲤AI suporta vários gêneros musicais, incluindo Pop, Rock, Clássico e Eletrônico.',
            },
            q5: {
                question: 'A música gerada é adequada para uso comercial?',
                answer: 'Sim, a música gerada em nossos planos pagos vem com uma licença comercial, permitindo que você a use em vídeos do YouTube, jogos e outros projetos comerciais.',
            },
        },
    },
    it: {
        heroTitle: 'Crea Musica Unica con 微鲤AI',
        heroHighlight: 'Generatore di Musica IA',
        whyChooseTitle: 'Perché Scegliere il Generatore di Musica IA di 微鲤AI?',
        whyChooseDesc:
            'Benvenuti nel Generatore di Musica IA di 微鲤AI! Il nostro strumento innovativo sfrutta il potere dell\'intelligenza artificiale per creare tracce musicali uniche e royalty-free in pochi secondi.',
        featuresTitle: 'Funzionalità Principali del Nostro Generatore di Musica IA',
        featuresSubtitle:
            'Il Generatore di Musica IA di 微鲤AI utilizza sofisticati algoritmi di deep learning per analizzare gli input degli utenti e generare composizioni musicali di alta qualità.',
        features: {
            music: {
                title: 'Generazione da Testo a Musica',
                desc: '微鲤AI utilizza sofisticati algoritmi di deep learning per analizzare i tuoi input testuali e generare composizioni musicali di alta qualità.',
            },
            style: {
                title: 'Molteplici Stili Musicali',
                desc: 'La nostra tecnologia supporta un\'ampia gamma di stili musicali, dalla classica all\'elettronica moderna.',
            },
            customize: {
                title: 'Personalizzazione Completa',
                desc: 'Scegli il genere, il tempo e l\'atmosfera della tua musica con varie opzioni di personalizzazione.',
            },
            copyright: {
                title: 'Musica Royalty-Free',
                desc: 'Crea tracce musicali uniche e royalty-free in pochi secondi. Perfetto per creatori di video, sviluppatori di giochi o appassionati di musica.',
            },
        },
        howToTitle: 'Come Usare il Generatore di Musica IA',
        howToSubtitle:
            'Iniziare con il Generatore di Musica IA di 微鲤AI è facilissimo. Segui questi semplici passaggi:',
        steps: {
            step1: {
                title: 'Visita il Sito Web',
                desc: 'Naviga alla pagina del Generatore di Musica IA di 微鲤AI.',
            },
            step2: {
                title: 'Seleziona il Tipo di Musica',
                desc: 'Scegli il genere di musica che vuoi generare dal menu a tendina.',
            },
            step3: {
                title: 'Imposta i Parametri',
                desc: 'Regola il tono emotivo, il tempo e la durata della musica in base alle esigenze del tuo progetto.',
            },
            step4: {
                title: 'Genera la Musica',
                desc: 'Clicca sul pulsante "Genera" e attendi qualche secondo per la creazione della tua traccia musicale unica.',
            },
            step5: {
                title: 'Scarica o Condividi',
                desc: 'La traccia musicale generata sarà disponibile per il download, e potrai anche condividerla direttamente sulle piattaforme social.',
            },
        },
        faqTitle: 'Domande Frequenti',
        faq: {
            q1: {
                question: 'Come funziona il Generatore di Musica IA di 微鲤AI?',
                answer: 'Basta selezionare il tipo di musica, impostare i parametri e cliccare su "Genera". L\'IA comporrà musica su misura per le tue specifiche.',
            },
            q2: {
                question: 'Il Generatore di Musica IA di 微鲤AI è gratuito?',
                answer: 'Sì, puoi generare un certo numero di tracce musicali gratuitamente ogni giorno. Per funzionalità aggiuntive o uso commerciale, considera i nostri piani premium.',
            },
            q3: {
                question: 'Posso personalizzare la musica generata?',
                answer: 'Assolutamente! Puoi personalizzare il tipo di musica, il tono emotivo e il tempo per assicurarti che la musica soddisfi le tue esigenze specifiche.',
            },
            q4: {
                question: 'Quali tipi di musica posso generare?',
                answer: '微鲤AI supporta vari generi musicali tra cui Pop, Rock, Classica ed Elettronica.',
            },
            q5: {
                question: 'La musica generata è adatta per uso commerciale?',
                answer: 'Sì, la musica generata con i nostri piani a pagamento include una licenza commerciale, permettendoti di usarla in video YouTube, giochi e altri progetti commerciali.',
            },
        },
    },
    ar: {
        heroTitle: 'أنشئ موسيقى فريدة مع 微鲤AI',
        heroHighlight: 'مولد الموسيقى بالذكاء الاصطناعي',
        whyChooseTitle: 'لماذا تختار مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI؟',
        whyChooseDesc:
            'مرحبًا بك في مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI! تستخدم أداتنا المبتكرة قوة الذكاء الاصطناعي لإنشاء مقاطع موسيقية فريدة وخالية من حقوق الملكية في ثوانٍ.',
        featuresTitle: 'الميزات الأساسية لمولد الموسيقى بالذكاء الاصطناعي',
        featuresSubtitle:
            'يستخدم مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI خوارزميات تعلم عميق متطورة لتحليل مدخلات المستخدم وإنشاء تركيبات موسيقية عالية الجودة.',
        features: {
            music: {
                title: 'توليد الموسيقى من النص',
                desc: 'يستخدم 微鲤AI خوارزميات تعلم عميق متطورة لتحليل مدخلاتك النصية وإنشاء تركيبات موسيقية عالية الجودة.',
            },
            style: {
                title: 'أنماط موسيقية متعددة',
                desc: 'تدعم تقنيتنا مجموعة واسعة من الأنماط الموسيقية، من الكلاسيكية إلى الإلكترونية الحديثة.',
            },
            customize: {
                title: 'تخصيص كامل',
                desc: 'اختر نوع الموسيقى والإيقاع والمزاج مع خيارات تخصيص متنوعة.',
            },
            copyright: {
                title: 'موسيقى خالية من حقوق الملكية',
                desc: 'أنشئ مقاطع موسيقية فريدة وخالية من حقوق الملكية في ثوانٍ. مثالية لمنشئي الفيديو ومطوري الألعاب أو عشاق الموسيقى.',
            },
        },
        howToTitle: 'كيفية استخدام مولد الموسيقى بالذكاء الاصطناعي',
        howToSubtitle:
            'البدء باستخدام مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI سهل للغاية. اتبع هذه الخطوات البسيطة:',
        steps: {
            step1: {
                title: 'زيارة الموقع',
                desc: 'انتقل إلى صفحة مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI.',
            },
            step2: {
                title: 'اختر نوع الموسيقى',
                desc: 'اختر نوع الموسيقى الذي تريد إنشاءه من القائمة المنسدلة.',
            },
            step3: {
                title: 'ضبط المعلمات',
                desc: 'اضبط النغمة العاطفية والإيقاع وطول الموسيقى وفقًا لاحتياجات مشروعك.',
            },
            step4: {
                title: 'إنشاء الموسيقى',
                desc: 'انقر على زر "إنشاء" وانتظر بضع ثوانٍ حتى يتم إنشاء المقطع الموسيقي الفريد الخاص بك.',
            },
            step5: {
                title: 'التنزيل أو المشاركة',
                desc: 'سيكون المقطع الموسيقي المُنشأ متاحًا للتنزيل، ويمكنك أيضًا مشاركته مباشرة على منصات التواصل الاجتماعي.',
            },
        },
        faqTitle: 'الأسئلة الشائعة',
        faq: {
            q1: {
                question: 'كيف يعمل مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI؟',
                answer: 'ما عليك سوى اختيار نوع الموسيقى وضبط المعلمات والنقر على "إنشاء". سيقوم الذكاء الاصطناعي بتأليف موسيقى مخصصة وفقًا لمواصفاتك.',
            },
            q2: {
                question: 'هل مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI مجاني؟',
                answer: 'نعم، يمكنك إنشاء عدد من المقاطع الموسيقية مجانًا كل يوم. للميزات الإضافية أو الاستخدام التجاري، يرجى النظر في خططنا المميزة.',
            },
            q3: {
                question: 'هل يمكنني تخصيص الموسيقى المُنشأة؟',
                answer: 'بالتأكيد! يمكنك تخصيص نوع الموسيقى والنغمة العاطفية والإيقاع لضمان أن الموسيقى تلبي احتياجاتك المحددة.',
            },
            q4: {
                question: 'ما أنواع الموسيقى التي يمكنني إنشاؤها؟',
                answer: 'يدعم 微鲤AI أنواعًا موسيقية متنوعة بما في ذلك البوب والروك والكلاسيك والإلكترونيك.',
            },
            q5: {
                question: 'هل الموسيقى المُنشأة مناسبة للاستخدام التجاري؟',
                answer: 'نعم، الموسيقى المُنشأة ضمن خططنا المدفوعة تأتي مع ترخيص تجاري، مما يتيح لك استخدامها في فيديوهات يوتيوب والألعاب والمشاريع التجارية الأخرى.',
            },
        },
    },
    tw: {
        // Hero Section
        heroTitle: '用 微鲤AI 的',
        heroHighlight: 'AI 音樂生成器',

        // Why Choose Section
        whyChooseTitle: '為什麼選擇 微鲤AI 的 AI 音樂生成器？',
        whyChooseDesc:
            '歡迎使用 微鲤AI 的 AI 音樂生成器！我們的創新工具運用人工智慧力量，在數秒內創作獨特且免版稅的音樂曲目。無論你是影片創作者、遊戲開發者或音樂愛好者，生成器都能滿足多樣需求。透過多種自訂選項，你可以輕鬆選擇曲風、節奏與情緒，讓作品更吸引人。',

        // Core Features Section
        featuresTitle: '我們的 AI 音樂生成器核心功能',
        featuresSubtitle:
            '微鲤AI 的 AI 音樂生成器運用精密的深度學習演算法分析使用者輸入並生成高品質的音樂作品。只需提供想要的曲風與情緒等基本資訊，系統便能生成符合需求的音樂。',
        features: {
            music: {
                title: '文字轉音樂生成',
                desc: '微鲤AI 運用精密的深度學習演算法分析文字輸入，產出符合需求的高品質音樂作品。',
            },
            style: {
                title: '多種音樂風格',
                desc: '技術支援從古典到現代電子等多樣曲風，確保你能找到最適合專案的風格。',
            },
            customize: {
                title: '完整自訂',
                desc: '透過多種自訂選項選擇曲風、節奏與情緒，讓作品更具吸引力。',
            },
            copyright: {
                title: '免版稅音樂',
                desc: '數秒內生成獨特的免版稅音樂，特別適合影片創作者、遊戲開發者與音樂愛好者。',
            },
        },

        // How to Use Section
        howToTitle: '如何使用 AI 音樂生成器',
        howToSubtitle:
            '開始使用 微鲤AI 的 AI 音樂生成器非常簡單，依照以下步驟：',
        steps: {
            step1: {
                title: '造訪網站',
                desc: '前往 微鲤AI AI 音樂生成器頁面。',
            },
            step2: {
                title: '選擇音樂類型',
                desc: '從下拉選單選擇要生成的曲風，例如流行、搖滾、古典或電子。',
            },
            step3: {
                title: '設定參數',
                desc: '依專案需求調整情緒、節奏與音樂長度，例如歡樂、抒情或激勵等主題。',
            },
            step4: {
                title: '生成音樂',
                desc: '點擊「Generate」按鈕，等待幾秒即可生成獨特音樂曲目。',
            },
            step5: {
                title: '下載或分享',
                desc: '生成的音樂可下載，亦可直接分享到社群平台。',
            },
        },

        // FAQ Section
        faqTitle: '常見問題',
        faq: {
            q1: {
                question: '微鲤AI 的 AI 音樂生成器如何運作？',
                answer: '只需選擇音樂類型、設定參數並點擊「Generate」，AI 便會依你的需求作曲。',
            },
            q2: {
                question: '微鲤AI 的 AI 音樂生成器免費嗎？',
                answer: '是的，你每天可以免費生成一定數量的曲目。若需更多功能或商用，請考慮我們的進階方案。',
            },
            q3: {
                question: '我可以自訂生成的音樂嗎？',
                answer: '當然可以！你可以自訂曲風、情緒與節奏，確保音樂符合你的需求。',
            },
            q4: {
                question: '我可以生成哪些類型的音樂？',
                answer: '微鲤AI 支援多種曲風，包括流行、搖滾、古典與電子等，可依偏好選擇。',
            },
            q5: {
                question: '生成的音樂可以商用嗎？',
                answer: '可以，付費方案生成的音樂附帶商業授權，可用於 YouTube 影片、遊戲與其他商業專案。',
            },
        },
    },
    pl: {
        // Hero Section
        heroTitle: 'Twórz unikalną muzykę z 微鲤AI',
        heroHighlight: 'Generatorem muzyki AI',

        // Why Choose Section
        whyChooseTitle: 'Dlaczego warto wybrać generator muzyki AI 微鲤AI?',
        whyChooseDesc:
            'Witamy w generatorze muzyki AI 微鲤AI! Nasze innowacyjne narzędzie wykorzystuje sztuczną inteligencję do tworzenia unikalnych, wolnych od tantiem utworów w kilka sekund. Niezależnie od tego, czy tworzysz wideo, gry, czy po prostu kochasz muzykę, generator został zaprojektowany tak, by spełnić różnorodne potrzeby. Dzięki opcjom personalizacji możesz łatwo wybrać gatunek, tempo i nastrój, dzięki czemu Twoje projekty będą bardziej angażujące.',

        // Core Features Section
        featuresTitle: 'Najważniejsze funkcje naszego generatora muzyki AI',
        featuresSubtitle:
            'Generator muzyki AI 微鲤AI wykorzystuje zaawansowane algorytmy głębokiego uczenia do analizy danych wejściowych i tworzenia wysokiej jakości kompozycji. Wystarczy podać podstawowe informacje, takie jak gatunek i nastrój, aby system stworzył muzykę zgodną z Twoimi wymaganiami.',
        features: {
            music: {
                title: 'Generowanie muzyki z tekstu',
                desc: '微鲤AI wykorzystuje zaawansowane algorytmy głębokiego uczenia do analizy tekstu i tworzenia wysokiej jakości kompozycji dopasowanych do Twoich wymagań.',
            },
            style: {
                title: 'Wiele stylów muzycznych',
                desc: 'Nasza technologia obsługuje szeroki zakres stylów muzycznych — od klasyki po nowoczesną elektronikę — abyś mógł znaleźć idealne dopasowanie.',
            },
            customize: {
                title: 'Pełna personalizacja',
                desc: 'Wybierz gatunek, tempo i nastrój dzięki różnym opcjom konfiguracji, aby Twoje projekty były bardziej angażujące.',
            },
            copyright: {
                title: 'Muzyka bez tantiem',
                desc: 'Twórz unikalne, wolne od tantiem utwory w kilka sekund. Idealne dla twórców wideo, deweloperów gier i miłośników muzyki.',
            },
        },

        // How to Use Section
        howToTitle: 'Jak korzystać z generatora muzyki AI',
        howToSubtitle:
            'Rozpoczęcie pracy z generatorem muzyki AI 微鲤AI jest proste. Wykonaj te kroki:',
        steps: {
            step1: {
                title: 'Odwiedź stronę',
                desc: 'Przejdź na stronę generatora muzyki AI 微鲤AI.',
            },
            step2: {
                title: 'Wybierz typ muzyki',
                desc: 'Z listy rozwijanej wybierz gatunek muzyki, np. pop, rock, klasykę lub elektronikę.',
            },
            step3: {
                title: 'Ustaw parametry',
                desc: 'Dostosuj nastrój, tempo i długość muzyki do potrzeb projektu. Opcje obejmują klimat energiczny, sentymentalny lub motywacyjny.',
            },
            step4: {
                title: 'Generuj muzykę',
                desc: 'Kliknij przycisk „Generate” i poczekaj kilka sekund na utworzenie unikalnej ścieżki.',
            },
            step5: {
                title: 'Pobierz lub udostępnij',
                desc: 'Wygenerowany utwór będzie dostępny do pobrania, a także do udostępnienia w mediach społecznościowych.',
            },
        },

        // FAQ Section
        faqTitle: 'Najczęściej zadawane pytania',
        faq: {
            q1: {
                question: 'Jak działa generator muzyki AI 微鲤AI?',
                answer: 'Wystarczy wybrać typ muzyki, ustawić parametry i kliknąć „Generate”. AI skomponuje muzykę zgodnie z Twoimi wymaganiami.',
            },
            q2: {
                question: 'Czy generator muzyki AI 微鲤AI jest darmowy?',
                answer: 'Tak, każdego dnia możesz wygenerować określoną liczbę utworów za darmo. Dodatkowe funkcje lub użycie komercyjne są dostępne w planach premium.',
            },
            q3: {
                question: 'Czy mogę spersonalizować wygenerowaną muzykę?',
                answer: 'Oczywiście! Możesz dostosować gatunek, nastrój i tempo, aby muzyka odpowiadała Twoim potrzebom.',
            },
            q4: {
                question: 'Jakie gatunki muzyki mogę generować?',
                answer: '微鲤AI obsługuje różne gatunki, w tym pop, rock, klasykę i elektronikę. Wybierz to, co lubisz.',
            },
            q5: {
                question: 'Czy wygenerowana muzyka nadaje się do użytku komercyjnego?',
                answer: 'Tak, muzyka generowana w ramach planów płatnych ma licencję komercyjną, dzięki czemu możesz używać jej w filmach na YouTube, grach i innych projektach.',
            },
        },
    },
    th: {
        // Hero Section
        heroTitle: 'สร้างเพลงที่ไม่ซ้ำด้วย',
        heroHighlight: 'เครื่องมือสร้างเพลง AI ของ 微鲤AI',

        // Why Choose Section
        whyChooseTitle: 'ทำไมต้องเลือกเครื่องมือสร้างเพลง AI ของ 微鲤AI?',
        whyChooseDesc:
            'ยินดีต้อนรับสู่เครื่องมือสร้างเพลง AI ของ 微鲤AI! เครื่องมือของเรานำพลังของปัญญาประดิษฐ์มาสร้างเพลงที่ไม่ซ้ำและปลอดค่าลิขสิทธิ์ภายในไม่กี่วินาที ไม่ว่าคุณจะเป็นครีเอเตอร์วิดีโอ นักพัฒนาเกม หรือคนรักดนตรี เครื่องมือนี้ถูกออกแบบมาเพื่อตอบโจทย์ที่หลากหลาย ด้วยตัวเลือกการปรับแต่งมากมาย คุณสามารถเลือกแนวเพลง จังหวะ และอารมณ์ได้ง่าย ๆ เพื่อให้โปรเจกต์ของคุณน่าสนใจยิ่งขึ้น',

        // Core Features Section
        featuresTitle: 'คุณสมบัติหลักของเครื่องมือสร้างเพลง AI ของเรา',
        featuresSubtitle:
            'เครื่องมือสร้างเพลง AI ของ 微鲤AI ใช้อัลกอริทึมการเรียนรู้เชิงลึกที่ซับซ้อนเพื่อวิเคราะห์อินพุตของผู้ใช้และสร้างเพลงคุณภาพสูง เพียงให้ข้อมูลพื้นฐาน เช่น แนวเพลงและโทนอารมณ์ ระบบก็จะประมวลผลและสร้างเพลงที่ตรงตามความต้องการของคุณ',
        features: {
            music: {
                title: 'การสร้างเพลงจากข้อความ',
                desc: '微鲤AI ใช้อัลกอริทึมการเรียนรู้เชิงลึกเพื่อวิเคราะห์ข้อความของคุณและสร้างเพลงคุณภาพสูงที่ตรงตามสเปก',
            },
            style: {
                title: 'สไตล์เพลงหลากหลาย',
                desc: 'เทคโนโลยีของเรารองรับสไตล์เพลงหลากหลาย ตั้งแต่คลาสสิกไปจนถึงอิเล็กทรอนิกส์สมัยใหม่ เพื่อให้คุณหาสไตล์ที่เหมาะกับโปรเจกต์ได้',
            },
            customize: {
                title: 'ปรับแต่งได้เต็มที่',
                desc: 'เลือกแนวเพลง จังหวะ และอารมณ์ผ่านตัวเลือกการปรับแต่งต่าง ๆ เพื่อให้โปรเจกต์ของคุณโดดเด่นขึ้น',
            },
            copyright: {
                title: 'เพลงปลอดค่าลิขสิทธิ์',
                desc: 'สร้างเพลงที่ไม่ซ้ำและปลอดค่าลิขสิทธิ์ในไม่กี่วินาที เหมาะสำหรับครีเอเตอร์วิดีโอ นักพัฒนาเกม และคนรักดนตรี',
            },
        },

        // How to Use Section
        howToTitle: 'วิธีใช้เครื่องมือสร้างเพลง AI',
        howToSubtitle:
            'เริ่มต้นใช้งานเครื่องมือสร้างเพลง AI ของ 微鲤AI ได้อย่างง่ายดาย ทำตามขั้นตอนเหล่านี้:',
        steps: {
            step1: {
                title: 'เข้าเว็บไซต์',
                desc: 'ไปที่หน้าเครื่องมือสร้างเพลง AI ของ 微鲤AI',
            },
            step2: {
                title: 'เลือกประเภทเพลง',
                desc: 'เลือกแนวเพลงจากเมนูดรอปดาวน์ เช่น ป็อป ร็อก คลาสสิก หรืออิเล็กทรอนิกส์',
            },
            step3: {
                title: 'ตั้งค่าพารามิเตอร์',
                desc: 'ปรับโทนอารมณ์ จังหวะ และความยาวของเพลงตามความต้องการของโปรเจกต์ เช่น ร่าเริง ซึ้ง หรือสร้างแรงบันดาลใจ',
            },
            step4: {
                title: 'สร้างเพลง',
                desc: 'คลิกปุ่ม "Generate" และรอสักครู่เพื่อให้เพลงของคุณถูกสร้างขึ้น',
            },
            step5: {
                title: 'ดาวน์โหลดหรือแชร์',
                desc: 'เพลงที่สร้างจะพร้อมให้ดาวน์โหลด และสามารถแชร์ไปยังโซเชียลมีเดียได้ทันที',
            },
        },

        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',
        faq: {
            q1: {
                question: 'เครื่องมือสร้างเพลง AI ของ 微鲤AI ทำงานอย่างไร?',
                answer: 'เพียงเลือกประเภทเพลง ตั้งค่าพารามิเตอร์ แล้วคลิก "Generate" AI จะประพันธ์เพลงให้ตรงตามที่คุณต้องการ',
            },
            q2: {
                question: 'เครื่องมือสร้างเพลง AI ของ 微鲤AI ใช้ฟรีไหม?',
                answer: 'ใช่ คุณสามารถสร้างเพลงได้ฟรีจำนวนหนึ่งต่อวัน หากต้องการฟีเจอร์เพิ่มเติมหรือใช้งานเชิงพาณิชย์ โปรดพิจารณาแผนพรีเมียมของเรา',
            },
            q3: {
                question: 'ฉันสามารถปรับแต่งเพลงที่สร้างได้ไหม?',
                answer: 'ได้แน่นอน! คุณสามารถปรับประเภทเพลง โทนอารมณ์ และจังหวะให้ตรงกับความต้องการของคุณ',
            },
            q4: {
                question: 'ฉันสามารถสร้างเพลงประเภทใดได้บ้าง?',
                answer: '微鲤AI รองรับแนวเพลงหลากหลาย เช่น ป็อป ร็อก คลาสสิก และอิเล็กทรอนิกส์ คุณสามารถเลือกตามความชอบได้',
            },
            q5: {
                question: 'เพลงที่สร้างเหมาะสำหรับการใช้งานเชิงพาณิชย์หรือไม่?',
                answer: 'ได้ เพลงที่สร้างในแผนชำระเงินจะมาพร้อมสิทธิ์ใช้งานเชิงพาณิชย์ สามารถใช้ในวิดีโอ YouTube เกม และโปรเจกต์เชิงพาณิชย์อื่น ๆ ได้',
            },
        },
    },
    da: {
        // Hero Section
        heroTitle: 'Skab unik musik med 微鲤AI\'s',
        heroHighlight: 'AI-musikgenerator',

        // Why Choose Section
        whyChooseTitle: 'Hvorfor vælge 微鲤AI\'s AI-musikgenerator?',
        whyChooseDesc:
            'Velkommen til 微鲤AI\'s AI-musikgenerator! Vores innovative værktøj udnytter kunstig intelligens til at skabe unikke, royaltyfri musiknumre på få sekunder. Uanset om du er videokreatør, spiludvikler eller musikelsker, er generatoren designet til at dække dine behov. Med forskellige tilpasningsmuligheder kan du nemt vælge genre, tempo og stemning, så dine projekter bliver mere engagerende.',

        // Core Features Section
        featuresTitle: 'Kernefunktioner i vores AI-musikgenerator',
        featuresSubtitle:
            '微鲤AI\'s AI-musikgenerator bruger avancerede deep learning-algoritmer til at analysere brugerinput og skabe musikkompositioner i høj kvalitet. Ved blot at angive grundlæggende oplysninger som ønsket genre og følelsesmæssig tone behandler systemet dataene og skaber musik, der matcher dine specifikationer.',
        features: {
            music: {
                title: 'Tekst-til-musik-generering',
                desc: '微鲤AI bruger avancerede deep learning-algoritmer til at analysere dine tekstinput og generere musikkompositioner i høj kvalitet, der matcher dine specifikationer.',
            },
            style: {
                title: 'Flere musikstile',
                desc: 'Teknologien understøtter et bredt udvalg af musikstile, fra klassisk til moderne elektronisk, så du kan finde det perfekte match til dit projekt.',
            },
            customize: {
                title: 'Fuld tilpasning',
                desc: 'Vælg genre, tempo og stemning med forskellige tilpasningsmuligheder, så dine projekter bliver mere engagerende.',
            },
            copyright: {
                title: 'Royaltyfri musik',
                desc: 'Skab unikke, royaltyfri musiknumre på få sekunder. Perfekt til videokreatører, spiludviklere eller musikentusiaster.',
            },
        },

        // How to Use Section
        howToTitle: 'Sådan bruger du AI-musikgeneratoren',
        howToSubtitle:
            'Det er nemt at komme i gang med 微鲤AI\'s AI-musikgenerator. Følg disse trin:',
        steps: {
            step1: {
                title: 'Besøg websitet',
                desc: 'Gå til 微鲤AI\'s side for AI-musikgeneratoren.',
            },
            step2: {
                title: 'Vælg musiktype',
                desc: 'Vælg genren fra dropdown-menuen, f.eks. pop, rock, klassisk eller elektronisk.',
            },
            step3: {
                title: 'Indstil parametre',
                desc: 'Justér følelsesmæssig tone, tempo og længde efter projektets behov. Muligheder omfatter opmuntrende, sentimental eller motiverende tema.',
            },
            step4: {
                title: 'Generér musik',
                desc: 'Klik på "Generate" og vent et par sekunder, mens dit unikke musiknummer bliver skabt.',
            },
            step5: {
                title: 'Download eller del',
                desc: 'Det genererede musiknummer kan downloades, og du kan også dele det direkte på sociale medier.',
            },
        },

        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',
        faq: {
            q1: {
                question: 'Hvordan fungerer 微鲤AI\'s AI-musikgenerator?',
                answer: 'Du vælger blot musiktype, indstiller parametre og klikker på "Generate". AI\'en komponerer musik, der passer til dine specifikationer.',
            },
            q2: {
                question: 'Er 微鲤AI\'s AI-musikgenerator gratis at bruge?',
                answer: 'Ja, du kan generere et antal musiknumre gratis hver dag. For ekstra funktioner eller kommerciel brug, se vores premium-planer.',
            },
            q3: {
                question: 'Kan jeg tilpasse den genererede musik?',
                answer: 'Helt sikkert! Du kan tilpasse musiktype, følelsesmæssig tone og tempo, så musikken matcher dine behov.',
            },
            q4: {
                question: 'Hvilke typer musik kan jeg generere?',
                answer: '微鲤AI understøtter mange genrer, herunder pop, rock, klassisk og elektronisk. Du kan vælge efter dine præferencer.',
            },
            q5: {
                question: 'Er den genererede musik egnet til kommerciel brug?',
                answer: 'Ja, musik genereret under vores betalte planer inkluderer en kommerciel licens, så du kan bruge den i YouTube-videoer, spil og andre kommercielle projekter.',
            },
        },
    },
    no: {
        // Hero Section
        heroTitle: 'Skap unik musikk med 微鲤AI sin',
        heroHighlight: 'AI-musikkgenerator',

        // Why Choose Section
        whyChooseTitle: 'Hvorfor velge 微鲤AI sin AI-musikkgenerator?',
        whyChooseDesc:
            'Velkommen til 微鲤AI sin AI-musikkgenerator! Vårt innovative verktøy bruker kraften i kunstig intelligens til å lage unike, royaltyfrie musikkspor på sekunder. Enten du er videoskaper, spillutvikler eller bare musikkelsker, er generatoren laget for å møte behovene dine. Med flere tilpasningsvalg kan du enkelt velge sjanger, tempo og stemning, og gjøre prosjektene mer engasjerende.',

        // Core Features Section
        featuresTitle: 'Kjernefunksjoner i vår AI-musikkgenerator',
        featuresSubtitle:
            '微鲤AI sin AI-musikkgenerator bruker avanserte deep learning-algoritmer for å analysere brukerinput og generere musikkkomposisjoner i høy kvalitet. Ved å oppgi grunnleggende informasjon som ønsket sjanger og emosjonell tone, lager systemet musikk som passer spesifikasjonene dine.',
        features: {
            music: {
                title: 'Tekst-til-musikk-generering',
                desc: '微鲤AI bruker avanserte deep learning-algoritmer for å analysere tekstinput og generere musikkkomposisjoner i høy kvalitet som matcher spesifikasjonene dine.',
            },
            style: {
                title: 'Flere musikkstiler',
                desc: 'Teknologien vår støtter et bredt spekter av musikkstiler, fra klassisk til moderne elektronisk, slik at du finner det perfekte match.',
            },
            customize: {
                title: 'Full tilpasning',
                desc: 'Velg sjanger, tempo og stemning med ulike tilpasningsmuligheter for å gjøre prosjektene mer engasjerende.',
            },
            copyright: {
                title: 'Royaltyfri musikk',
                desc: 'Lag unike, royaltyfrie musikkspor på sekunder. Perfekt for videokreatører, spillutviklere eller musikkentusiaster.',
            },
        },

        // How to Use Section
        howToTitle: 'Slik bruker du AI-musikkgeneratoren',
        howToSubtitle:
            'Det er enkelt å komme i gang med 微鲤AI sin AI-musikkgenerator. Følg disse trinnene:',
        steps: {
            step1: {
                title: 'Besøk nettstedet',
                desc: 'Gå til 微鲤AI-siden for AI-musikkgeneratoren.',
            },
            step2: {
                title: 'Velg musikktype',
                desc: 'Velg sjangeren du vil generere fra rullegardinmenyen, for eksempel pop, rock, klassisk eller elektronisk.',
            },
            step3: {
                title: 'Sett parametere',
                desc: 'Juster følelsesmessig tone, tempo og lengde etter prosjektets behov. Alternativer inkluderer livlig, sentimental eller motiverende tema.',
            },
            step4: {
                title: 'Generer musikk',
                desc: 'Klikk på "Generate" og vent noen sekunder til ditt unike musikkspor er klart.',
            },
            step5: {
                title: 'Last ned eller del',
                desc: 'Det genererte musikksporet kan lastes ned, og du kan også dele det direkte på sosiale medier.',
            },
        },

        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',
        faq: {
            q1: {
                question: 'Hvordan fungerer 微鲤AI sin AI-musikkgenerator?',
                answer: 'Du velger musikktype, setter parametere og klikker "Generate". AI-en komponerer musikk etter dine spesifikasjoner.',
            },
            q2: {
                question: 'Er 微鲤AI sin AI-musikkgenerator gratis å bruke?',
                answer: 'Ja, du kan generere et antall musikkspor gratis hver dag. For ekstra funksjoner eller kommersiell bruk, se våre premiumplaner.',
            },
            q3: {
                question: 'Kan jeg tilpasse den genererte musikken?',
                answer: 'Absolutt! Du kan tilpasse musikktype, følelsesmessig tone og tempo for å sikre at musikken møter behovene dine.',
            },
            q4: {
                question: 'Hvilke typer musikk kan jeg generere?',
                answer: '微鲤AI støtter mange sjangre, inkludert pop, rock, klassisk og elektronisk. Du kan velge etter dine preferanser.',
            },
            q5: {
                question: 'Er den genererte musikken egnet for kommersiell bruk?',
                answer: 'Ja, musikk generert under våre betalte planer inkluderer en kommersiell lisens, slik at du kan bruke den i YouTube-videoer, spill og andre kommersielle prosjekter.',
            },
        },
    },
    nl: {
        // Hero Section
        heroTitle: 'Maak unieke muziek met 微鲤AI\'s',
        heroHighlight: 'AI-muziekgenerator',

        // Why Choose Section
        whyChooseTitle: 'Waarom kiezen voor 微鲤AI\'s AI-muziekgenerator?',
        whyChooseDesc:
            'Welkom bij de AI-muziekgenerator van 微鲤AI! Onze innovatieve tool gebruikt kunstmatige intelligentie om in enkele seconden unieke, royaltyvrije muziek te maken. Of je nu videocreator, gameontwikkelaar of muziekliefhebber bent, de generator is ontworpen om aan jouw behoeften te voldoen. Met verschillende personalisatie-opties kun je eenvoudig het genre, tempo en de sfeer kiezen, zodat je projecten aantrekkelijker worden.',

        // Core Features Section
        featuresTitle: 'Kernfuncties van onze AI-muziekgenerator',
        featuresSubtitle:
            'De AI-muziekgenerator van 微鲤AI gebruikt geavanceerde deep-learningalgoritmen om gebruikersinput te analyseren en hoogwaardige muziekcomposities te genereren. Door basisinformatie zoals het gewenste genre en de emotionele toon te geven, verwerkt het AI-systeem deze data en maakt het muziek die aansluit op je specificaties.',
        features: {
            music: {
                title: 'Tekst-naar-muziek',
                desc: '微鲤AI gebruikt geavanceerde deep-learningalgoritmen om je tekstinput te analyseren en hoogwaardige muziek te genereren die past bij je specificaties.',
            },
            style: {
                title: 'Meerdere muziekstijlen',
                desc: 'Onze technologie ondersteunt een breed scala aan stijlen, van klassiek tot moderne elektronische muziek, zodat je altijd een passende stijl vindt.',
            },
            customize: {
                title: 'Volledige personalisatie',
                desc: 'Kies genre, tempo en sfeer met verschillende personalisatie-opties om je projecten aantrekkelijker te maken.',
            },
            copyright: {
                title: 'Royaltyvrije muziek',
                desc: 'Maak in enkele seconden unieke, royaltyvrije muziek. Perfect voor videocreators, gameontwikkelaars en muziekliefhebbers.',
            },
        },

        // How to Use Section
        howToTitle: 'Hoe gebruik je de AI-muziekgenerator',
        howToSubtitle:
            'Aan de slag met de AI-muziekgenerator van 微鲤AI is eenvoudig. Volg deze stappen:',
        steps: {
            step1: {
                title: 'Bezoek de website',
                desc: 'Ga naar de 微鲤AI AI-muziekgeneratorpagina.',
            },
            step2: {
                title: 'Selecteer muzieksoort',
                desc: 'Kies het genre dat je wilt genereren via het dropdownmenu, zoals pop, rock, klassiek of elektronisch.',
            },
            step3: {
                title: 'Stel parameters in',
                desc: 'Pas de emotionele toon, het tempo en de lengte aan op je projectbehoeften. Opties zijn o.a. energiek, sentimenteel of motiverend.',
            },
            step4: {
                title: 'Genereer muziek',
                desc: 'Klik op "Generate" en wacht enkele seconden tot je unieke muziek is gemaakt.',
            },
            step5: {
                title: 'Download of deel',
                desc: 'De gegenereerde muziek is beschikbaar om te downloaden en kan ook direct gedeeld worden op sociale media.',
            },
        },

        // FAQ Section
        faqTitle: 'Veelgestelde vragen',
        faq: {
            q1: {
                question: 'Hoe werkt de AI-muziekgenerator van 微鲤AI?',
                answer: 'Je selecteert de muzieksoort, stelt je parameters in en klikt op "Generate". De AI componeert muziek die past bij je specificaties.',
            },
            q2: {
                question: 'Is de AI-muziekgenerator van 微鲤AI gratis?',
                answer: 'Ja, je kunt elke dag een aantal nummers gratis genereren. Voor extra functies of commercieel gebruik kun je onze premiumplannen overwegen.',
            },
            q3: {
                question: 'Kan ik de gegenereerde muziek aanpassen?',
                answer: 'Zeker! Je kunt de muzieksoort, emotionele toon en het tempo aanpassen zodat de muziek aan je wensen voldoet.',
            },
            q4: {
                question: 'Welke muzieksoorten kan ik genereren?',
                answer: '微鲤AI ondersteunt diverse genres zoals pop, rock, klassiek en elektronisch. Je kunt kiezen wat je het liefst wilt.',
            },
            q5: {
                question: 'Is de gegenereerde muziek geschikt voor commercieel gebruik?',
                answer: 'Ja, muziek die wordt gegenereerd via betaalde plannen bevat een commerciële licentie, zodat je deze kunt gebruiken in YouTube-video\'s, games en andere commerciële projecten.',
            },
        },
    },
    id: {
        // Hero Section
        heroTitle: 'Ciptakan musik unik dengan',
        heroHighlight: 'Generator Musik AI 微鲤AI',

        // Why Choose Section
        whyChooseTitle: 'Mengapa memilih Generator Musik AI 微鲤AI?',
        whyChooseDesc:
            'Selamat datang di Generator Musik AI 微鲤AI! Alat inovatif kami memanfaatkan kecerdasan buatan untuk menciptakan trek musik unik dan bebas royalti dalam hitungan detik. Baik Anda kreator video, pengembang game, atau pecinta musik, generator ini dirancang untuk memenuhi kebutuhan Anda. Dengan berbagai opsi kustomisasi, Anda dapat memilih genre, tempo, dan suasana musik dengan mudah agar proyek Anda lebih menarik.',

        // Core Features Section
        featuresTitle: 'Fitur inti generator musik AI kami',
        featuresSubtitle:
            'Generator Musik AI 微鲤AI menggunakan algoritma deep learning canggih untuk menganalisis input pengguna dan menghasilkan komposisi musik berkualitas tinggi. Dengan memberikan informasi dasar seperti genre dan nada emosional yang diinginkan, sistem AI memproses data ini untuk membuat musik sesuai spesifikasi Anda.',
        features: {
            music: {
                title: 'Generasi musik dari teks',
                desc: '微鲤AI menggunakan algoritma deep learning canggih untuk menganalisis input teks dan menghasilkan komposisi musik berkualitas tinggi sesuai spesifikasi Anda.',
            },
            style: {
                title: 'Beragam gaya musik',
                desc: 'Teknologi kami mendukung beragam gaya musik, dari klasik hingga elektronik modern, sehingga Anda bisa menemukan yang paling cocok.',
            },
            customize: {
                title: 'Kustomisasi penuh',
                desc: 'Pilih genre, tempo, dan suasana dengan berbagai opsi kustomisasi agar proyek Anda lebih menarik.',
            },
            copyright: {
                title: 'Musik bebas royalti',
                desc: 'Buat trek musik unik dan bebas royalti dalam hitungan detik. Cocok untuk kreator video, pengembang game, atau pecinta musik.',
            },
        },

        // How to Use Section
        howToTitle: 'Cara menggunakan Generator Musik AI',
        howToSubtitle:
            'Memulai dengan Generator Musik AI 微鲤AI sangat mudah. Ikuti langkah-langkah ini:',
        steps: {
            step1: {
                title: 'Kunjungi situs',
                desc: 'Buka halaman Generator Musik AI 微鲤AI.',
            },
            step2: {
                title: 'Pilih jenis musik',
                desc: 'Pilih genre dari menu dropdown, seperti Pop, Rock, Klasik, atau Elektronik.',
            },
            step3: {
                title: 'Atur parameter',
                desc: 'Sesuaikan nada emosional, tempo, dan durasi musik sesuai kebutuhan proyek. Opsi termasuk ceria, sentimental, atau motivasional.',
            },
            step4: {
                title: 'Buat musik',
                desc: 'Klik tombol "Generate" dan tunggu beberapa detik hingga trek unik Anda dibuat.',
            },
            step5: {
                title: 'Unduh atau bagikan',
                desc: 'Trek musik yang dihasilkan tersedia untuk diunduh dan bisa dibagikan langsung ke media sosial.',
            },
        },

        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',
        faq: {
            q1: {
                question: 'Bagaimana cara kerja Generator Musik AI 微鲤AI?',
                answer: 'Anda cukup memilih jenis musik, mengatur parameter, lalu klik "Generate". AI akan menggubah musik sesuai spesifikasi Anda.',
            },
            q2: {
                question: 'Apakah Generator Musik AI 微鲤AI gratis?',
                answer: 'Ya, Anda dapat membuat sejumlah trek musik gratis setiap hari. Untuk fitur tambahan atau penggunaan komersial, silakan pertimbangkan paket premium kami.',
            },
            q3: {
                question: 'Bisakah saya menyesuaikan musik yang dihasilkan?',
                answer: 'Tentu! Anda dapat menyesuaikan jenis musik, nada emosional, dan tempo agar sesuai kebutuhan Anda.',
            },
            q4: {
                question: 'Jenis musik apa saja yang bisa saya buat?',
                answer: '微鲤AI mendukung berbagai genre termasuk Pop, Rock, Klasik, dan Elektronik. Anda dapat memilih sesuai preferensi.',
            },
            q5: {
                question: 'Apakah musik yang dihasilkan cocok untuk penggunaan komersial?',
                answer: 'Ya, musik yang dihasilkan di paket berbayar dilengkapi lisensi komersial, sehingga dapat digunakan di video YouTube, game, dan proyek komersial lainnya.',
            },
        },
    },
    tr: {
        // Hero Section
        heroTitle: '微鲤AI ile benzersiz müzik oluşturun',
        heroHighlight: 'Yapay Zeka Müzik Üreticisi',

        // Why Choose Section
        whyChooseTitle: 'Neden 微鲤AI Yapay Zeka Müzik Üreticisini seçmelisiniz?',
        whyChooseDesc:
            '微鲤AI Yapay Zeka Müzik Üreticisine hoş geldiniz! Yenilikçi aracımız, yapay zekanın gücünü kullanarak saniyeler içinde benzersiz ve telifsiz müzik parçaları oluşturur. İster video üreticisi, ister oyun geliştiricisi, ister sadece müzik sever olun, bu araç ihtiyaçlarınıza göre tasarlanmıştır. Çeşitli özelleştirme seçenekleriyle tür, tempo ve ruh halini kolayca seçebilir, projelerinizi daha etkileyici hale getirebilirsiniz.',

        // Core Features Section
        featuresTitle: 'AI müzik üreticimizin temel özellikleri',
        featuresSubtitle:
            '微鲤AI Yapay Zeka Müzik Üreticisi, kullanıcı girdilerini analiz etmek ve yüksek kaliteli müzik kompozisyonları oluşturmak için gelişmiş derin öğrenme algoritmalarını kullanır. İstenen tür ve duygusal ton gibi temel bilgileri vererek, sistem bu verileri işler ve spesifikasyonlarınıza uygun müzik üretir.',
        features: {
            music: {
                title: 'Metinden müziğe üretim',
                desc: '微鲤AI, metin girdilerinizi analiz etmek ve spesifikasyonlarınıza uygun yüksek kaliteli müzik kompozisyonları üretmek için gelişmiş derin öğrenme algoritmaları kullanır.',
            },
            style: {
                title: 'Birden fazla müzik stili',
                desc: 'Teknolojimiz klasik müzikten modern elektronik müziğe kadar geniş bir yelpazeyi destekler; böylece projenize uygun olanı bulursunuz.',
            },
            customize: {
                title: 'Tam özelleştirme',
                desc: 'Farklı özelleştirme seçenekleriyle müziğinizin türünü, temposunu ve ruh halini seçerek projelerinizi daha etkileyici hale getirin.',
            },
            copyright: {
                title: 'Telifsiz müzik',
                desc: 'Saniyeler içinde benzersiz, telifsiz müzik parçaları oluşturun. Video üreticileri, oyun geliştiricileri ve müzik tutkunları için idealdir.',
            },
        },

        // How to Use Section
        howToTitle: 'Yapay zeka müzik üreticisi nasıl kullanılır',
        howToSubtitle:
            '微鲤AI Yapay Zeka Müzik Üreticisini kullanmaya başlamak çok kolay. Bu basit adımları izleyin:',
        steps: {
            step1: {
                title: 'Web sitesini ziyaret edin',
                desc: '微鲤AI Yapay Zeka Müzik Üreticisi sayfasına gidin.',
            },
            step2: {
                title: 'Müzik türünü seçin',
                desc: 'Açılır menüden Pop, Rock, Klasik veya Elektronik gibi oluşturmak istediğiniz müzik türünü seçin.',
            },
            step3: {
                title: 'Parametreleri ayarlayın',
                desc: 'Proje ihtiyaçlarınıza göre duygusal tonu, tempoyu ve müzik süresini ayarlayın. Seçenekler arasında neşeli, duygusal veya motive edici temalar bulunur.',
            },
            step4: {
                title: 'Müziği üretin',
                desc: '"Generate" düğmesine tıklayın ve benzersiz müzik parçanızın oluşturulması için birkaç saniye bekleyin.',
            },
            step5: {
                title: 'İndir veya paylaş',
                desc: 'Oluşturulan müzik parçası indirilebilir olacak ve ayrıca sosyal medya platformlarında doğrudan paylaşılabilecektir.',
            },
        },

        // FAQ Section
        faqTitle: 'Sıkça Sorulan Sorular',
        faq: {
            q1: {
                question: '微鲤AI Yapay Zeka Müzik Üreticisi nasıl çalışır?',
                answer: 'Sadece müzik türünü seçer, parametreleri ayarlar ve "Generate" düğmesine tıklarsınız. Yapay zeka, taleplerinize uygun müzik besteler.',
            },
            q2: {
                question: '微鲤AI Yapay Zeka Müzik Üreticisi ücretsiz mi?',
                answer: 'Evet, her gün belirli sayıda müzik parçasını ücretsiz oluşturabilirsiniz. Ek özellikler veya ticari kullanım için premium planlarımızı değerlendirin.',
            },
            q3: {
                question: 'Oluşturulan müziği özelleştirebilir miyim?',
                answer: 'Elbette! Müzik türünü, duygusal tonu ve tempoyu özelleştirerek ihtiyaçlarınıza uygun hale getirebilirsiniz.',
            },
            q4: {
                question: 'Hangi tür müzikler üretebilirim?',
                answer: '微鲤AI; Pop, Rock, Klasik ve Elektronik gibi birçok türü destekler. Tercihinize göre seçim yapabilirsiniz.',
            },
            q5: {
                question: 'Oluşturulan müzik ticari kullanım için uygun mu?',
                answer: 'Evet, ücretli planlarda oluşturulan müzikler ticari lisansla gelir; YouTube videolarında, oyunlarda ve diğer ticari projelerde kullanılabilir.',
            },
        },
    },
}

